import { Partner } from "../../types";
import { getShortenedName } from "../../utils/utils";
import Button from "../../VibehutUI/Button";
import SpecificChat from "../chat/SpecificChat";

interface Props {
  partner: Partner;
}

export const PartnerCard = ({ partner }: Props) => {
  return (
    <div className="flex flex-row w-full h-full justify-between py-2">
      <div className="flex flex-row w-full h-full gap-2">
        <div>
          <img
            src={partner.icon}
            alt="partner icon"
            className="w-14 h-14 rounded-md"
          />
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="flex flex-row gap-5">
            <p className="font-semibold text-start">
              {getShortenedName(partner.title, 20)}
            </p>
            {partner?.tag && (
              <p className="bg-primary uppercase text-frescoWhite rounded-md px-[8px] text-center flex justify-items-center items-center text-[10px]">
                {partner.tag}
              </p>
            )}
          </span>
          <div className="max-w-[250px] flex flex-wrap">
            <p className="text-xs">
              {getShortenedName(partner.description, 80)}
            </p>
          </div>
        </div>
      </div>
      <div>
        {partner.type === "software" ? (
          <Button
            onClick={() => {
              window.open(partner.link, "_blank");
            }}
            variant="vibhut-primary-outline"
          >
            Open
          </Button>
        ) : (
          <SpecificChat chatItem={partner} type="partner" />
        )}
      </div>
    </div>
  );
};
